import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';


function SideMenu({ isSidebarOpen, toggleSidebar }) {

    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuhome) => {
        setOpenMenu(openMenu === menuhome ? null : menuhome);
    };

    return (
        <div>
            <div id="side-bar" className={`side-bar ${isSidebarOpen ? 'show' : ''}`}>
                <button className="close-icon-menu" aria-label="Close Menu" onClick={toggleSidebar}>
                    <i className="far fa-times"></i>
                </button>
                {/* inner menu area desktop start */}
                <div className="rts-sidebar-menu-desktop">
                    <Link className="logo-1" to="/">
                        <img
                            className="logo"
                            src={`${process.env.PUBLIC_URL}/assets/images_new/logo.png`}
                            alt="izodrom_grup"
                        />
                    </Link>
                    <div className="body d-none d-xl-block">
                        <p className="disc">
                            Izodrom Grup - lider în sectorul construcțiilor și infrastructurii inginerești din Republica Moldova. 
                            Peste 20 de ani de expertiză în proiecte complexe.
                        </p>
                        <div className="get-in-touch">
                            {/* title */}
                            <div className="h6 title">Contactează-ne</div>
                            {/* title End */}
                            <div className="wrapper">
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-phone-alt" />
                                    <Link to="#">+373 268 25-763</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-envelope" />
                                    <Link to="#">office@izodrom.md</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-globe" />
                                    <Link to="#">www.izodrom.md</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-map-marker-alt" />
                                    <Link to="#">Str. Ialoveni nr. 2, Ialoveni, MD-6801</Link>
                                </div>
                                {/* single ENd */}
                            </div>
                            <div className="social-wrapper-two menu">
                                <Link to="#">
                                    <i className="fab fa-facebook-f" />
                                </Link>
                                <Link to="#">
                                    <i className="fab fa-linkedin" />
                                </Link>
                                <Link to="#">
                                    <i className="fab fa-instagram" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="body-mobile d-block d-xl-none">
                        <nav className="nav-main mainmenu-nav">
                            <ul className="mainmenu metismenu" id="mobile-menu-active">
                                <li className="menu-item">
                                    <Link className="menu-link" to={'/'}>
                                        Acasă
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link" to={'/about-us'}>
                                        Despre Noi
                                    </Link>
                                </li>
                                <li className="has-droupdown menu-item">
                                    <Link className="menu-link" href="#" onClick={() => toggleMenu(1)}>
                                        Proiecte
                                    </Link>
                                    <ul className={`submenu ${openMenu === 1 ? 'mm-collapse mm-show' : 'mm-collapse'}`} >
                                        <li className="mobile-menu-link">
                                            <Link to={'/project'}>Toate Proiectele</Link>
                                        </li>
                                        <li className="mobile-menu-link">
                                            <Link to={'/project-details'}>Detalii Proiect</Link>
                                        </li>
                                        <li className="mobile-menu-link">
                                            <Link to={'/constructions'}>Construcții Civile</Link>
                                        </li>
                                        <li className="mobile-menu-link">
                                            <Link to={'/water-systems'}>Sisteme Apă & Canalizare</Link>
                                        </li>
                                        <li className="mobile-menu-link">
                                            <Link to={'/wastewater-treatment'}>Stații de Epurare</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link" to={'/careers'}>
                                        Carieră
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link" to={'/contactus'}>
                                        Contact
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <div className="social-wrapper-two menu mobile-menu">
                            <Link to="#">
                                <i className="fab fa-facebook-f" />
                            </Link>
                            <Link to="#">
                                <i className="fab fa-linkedin" />
                            </Link>
                            <Link to="#">
                                <i className="fab fa-instagram" />
                            </Link>
                        </div>
                        <Link
                            to="/contactus"
                            className="rts-btn btn-primary ml--20 ml_sm--5 header-one-btn quote-btnmenu"
                        >
                            Solicită Ofertă
                        </Link>
                    </div>
                </div>
                {/* inner menu area desktop End */}
            </div>
        </div>
    )
}

export default SideMenu